<template>
  <img
    :src="placeholder"
    :data-src="url"
    :data-srcset="fixedSize ? '' : srcset"
    data-sizes="auto"
    class="vimg"
    :class="[customClass, { lazyload: url }]"
    @lazyloaded="$emit('loaded')" />
</template>

<script>
export default {
  name: 'VImg',

  props: {
    media: {
      type: Object,
    },
    src: {
      type: String,
    },
    fixedSize: {
      type: String,
    },
    customClass: {
      type: Object,
    },
  },

  computed: {
    url() {
      if (this.media)
        return this.fixedSize
          ? this.$image(this.media.src, this.fixedSize)
          : this.$image(this.media.src);
      if (this.src)
        return this.fixedSize
          ? this.$image(this.src, this.fixedSize)
          : this.$image(this.src);
      return null;
    },
    srcset() {
      if (this.fixedSize || !this.media) return null;

      let srcset = `${this.$image(this.media.src, '200x')} 100w`;
      this.media.width >= 200
        ? (srcset += `, ${this.$image(this.media.src, '400x')} 200w`)
        : '';
      this.media.width >= 400
        ? (srcset += `, ${this.$image(this.media.src, '800x')} 400w`)
        : '';
      this.media.width >= 600
        ? (srcset += `, ${this.$image(this.media.src, '1200x')} 600w`)
        : '';
      this.media.width >= 800
        ? (srcset += `, ${this.$image(this.media.src, '1600x')} 800w`)
        : '';
      this.media.width >= 1000
        ? (srcset += `, ${this.$image(this.media.src, '2000x')} 1000w`)
        : '';
      this.media.width >= 1500
        ? (srcset += `, ${this.$image(this.media.src, '3000x')} 1500w`)
        : '';
      this.media.width >= 2000
        ? (srcset += `, ${this.$image(this.media.src, '4000x')} 2000w`)
        : '';

      return srcset;
    },
    placeholder() {
      const w = this.media?.width;
      const h = this.media?.height;
      if (w && h) {
        return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"%3E%3C/svg%3E`;
      }
      return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"%3E%3C/svg%3E';
    },
  },
};
</script>

<style lang="scss" scoped>
.vimg {
  background-image: url("data:image/svg+xml,%3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='133.333' height='133.333' viewBox='0 0 100 100'%3E%3Cpath d='M37.8 11.9c-14.7 4.8-24.5 16.3-27.6 32.4-1.3 6.8.3 16.9 3.9 23.9 3.3 6.4 11.5 14.4 18.2 17.8 9.7 4.8 9.7 4.9 9.7-8 0-6.1.3-11 .8-11 .4 0 1.6 1.5 2.7 3.3C46.9 72.5 47.6 76 48 82c.4 6.7.8 8.5 2 8.5s1.6-1.7 1.8-7.8l.3-7.9L37 51.4c-8.2-12.9-15-23.7-15-24 0-.2 1.5-.4 3.3-.4 3.1.1 3.7.8 17.9 23.3L58 73.5v7.7c0 6.9.2 7.8 1.8 7.8 3.8 0 14-6.1 19-11.3 6.2-6.6 8.9-11.9 10.8-20.8 2.7-13-2-26.4-12.8-36.4-7.3-6.8-14.5-9.7-25.3-10.1-5.9-.3-9.5.1-13.7 1.5zm9 27.8c4.3 6.7 7.9 12.2 8.2 12.2.3.1 4.1-5.5 8.5-12.4C71.1 27.6 71.7 27 74.8 27c1.9 0 3.2.4 3 .8C77.1 29.7 55.5 63 55 63c-.6-.1-22-34.4-22-35.4 0-.4 1.4-.6 3.1-.4 2.8.3 3.9 1.6 10.7 12.5zM67 27.6C67 28.7 55.8 46 55 46c-.3 0-1.3-1.1-2-2.5-1.2-2.3-1-3 3.3-9.5 4.1-6.1 5.1-7 7.7-7 1.7 0 3 .3 3 .6z' fill='%23CCC'/%3E%3C/svg%3E");
  background-color: var(--silver);
  background-repeat: no-repeat;
  background-size: 25%;
  background-position: center;
}

.lazyloaded:not(.remove-transition) {
  transition: background-color 0.275s;
  background-color: transparent;
  background-image: none;
}
</style>
